'use strict';

var ServiceKpiRibbonFilterFactory = function ServiceKpiRibbonFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandDowFilterFactory', 'ServiceDemandClassFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function KpiRibbonFilter() {
    DemandFilter.call(this, 'service', 'kpi-ribbon');
    this.registerFilters(injectedFilters);
  }
  KpiRibbonFilter.constructor = KpiRibbonFilter;
  KpiRibbonFilter.prototype = Object.create(DemandFilter.prototype);
  return KpiRibbonFilter;
};
ServiceKpiRibbonFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ServiceKpiRibbonFilterFactory;